import { styled } from '../styled';

const Wrap = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

const Row = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  fontSize: 13,
  color: 'var(--qhs-text-2)',
  lineHeight: 1.55,
  '& strong': {
    color: 'var(--qhs-text-1)',
    fontWeight: 600,
  },
});

const Tick = styled('span')({
  flexShrink: 0,
  marginTop: 2,
  color: 'var(--qhs-success, #41C377)',
  '& svg': { width: 14, height: 14 },
});

const Mono = styled('span')({
  fontFamily: "'Source Code Pro', 'JetBrains Mono', monospace",
  fontSize: 12,
  color: 'var(--qhs-text-1)',
});

const TickIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/**
 * items = [{ strong: string, body: string, mono?: string }]
 *   - `strong` renders as bold prefix
 *   - `body` is appended after the bold prefix
 *   - `mono` (optional) renders inside body wherever the literal token
 *     `{{mono}}` appears in `body`. Splits body on the placeholder.
 */
const InfoList = ({ items }) => (
  <Wrap>
    {items.map((item, idx) => {
      const parts = item.mono ? item.body.split('{{mono}}') : [item.body];
      return (
        <Row key={idx}>
          <Tick>
            <TickIcon />
          </Tick>
          <span>
            <strong>{item.strong}</strong>
            {parts.length === 1 ? (
              <> &middot; {parts[0]}</>
            ) : (
              <>
                {' \u00b7 '}
                {parts[0]}
                <Mono>{item.mono}</Mono>
                {parts[1]}
              </>
            )}
          </span>
        </Row>
      );
    })}
  </Wrap>
);

export default InfoList;
